import React, { Component } from 'react';
import { connect } from 'react-redux';

import materialTabService from '../../../../services/requests/material-tab.service';
import Spinner from '../../../../components/LoadingStyles/Spinner';
import './styles.scss';
import {
  setReinforcementPlate,
  setReinforcementEdge,
  setReinforcementToLimit,
  setReinforcementLongTemp,
  setReinforcementShortTemp,
  setHoleConditions,
  setDrillingConditions
} from '@reducers/selectors/material/actions';
import { APP_TEXTS } from '../../../../texts/texts';

import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';
import { standardList } from '../../../../../src/app.values';
import Input from '@components/Input';

class ReinforcementAndConditions_EU_AS extends Component {

  static defaultProps = {
    options: {}
  };

  plates = [];
  edges = [];
  conditions = [];
  drillingConditions = [];
  longTermTemp = '';
  shortTermTemp = '';

  constructor(props) {
    super(props);
    this.state = {
      isPending: false,
    };
  }

  componentDidMount() {
    this.fetchOptions();
  }

  componentDidUpdate(prevProps) {
    if (Number(this.props.designStd) !== Number(prevProps.designStd))
      this.fetchOptions();
  }

  fetchOptions() {
    this.setState({ isPending: true });
    Promise.all([
      materialTabService.getPlateReinforcement(),
      materialTabService.getEdgeReinforcement(),
      materialTabService.getLongTermTemperature(),
      materialTabService.getShortTermTemperature(),
      materialTabService.getHoleConditions(),
      materialTabService.getInstallationConditions()
    ])
      .then(this.handleResponse)
      .then(
        this.unsetPending,
        this.unsetPending
      );
  }

  handleResponse = ([plates, edges, longTermTemp, shortTermTemp, conditions, drillingConditions]) => {
    this.plates = plates;
    this.edges = edges;
    this.longTermTemp = longTermTemp;
    this.shortTermTemp = shortTermTemp;
    this.conditions = conditions;
    this.drillingConditions = drillingConditions;
  };

  unsetPending = () => this.setState({ isPending: false });

  onSelect = (e) => this.setState({ [e.target.name]: e.target.value });
    

  render() {
    return (
      <div className="calculation">
        { this.state.isPending && <Spinner /> }

        <section className="list-type">
          <h4 className="reinforcement__title">{APP_TEXTS.MATERIAL_LABEL_PLATE_REINFORCEMENT.Content}</h4>
          <Tooltip content={APP_TOOLTIPS.TOOLTIP_REINFORCEMENT_TYPE.Content}>
          <select
            className="form-control reinforcement__select"
            value={this.props.chosenPlate}
            name="chosenPlate"
            onChange={e => this.props.setReinforcementPlate(e.target.value)}
          >
          
            {this.plates && this.plates.length && this.plates.map(n => (
              <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
            ))}
          </select>
          </Tooltip>

          <h4 className="reinforcement__title">{APP_TEXTS.MATERIAL_LABEL_EDGE_REINFORCEMENT.Content}</h4>
          <Tooltip content={APP_TOOLTIPS.TOOLTIP_REINFORCEMENT_EDGE.Content}>
          <select
            name="chosenEdge"
            className="form-control reinforcement__select"
            value={this.props.chosenEdge}
            onChange={e => this.props.setReinforcementEdge(e.target.value)}
          >
            {this.edges && this.edges.length && this.edges.map(n => (
              <option value={n['InternalName']} key={n['InternalName']} >{n['RunName']}</option>
            ))}
          </select>
          </Tooltip>

          <br/>
          <div className="custom-control custom-checkbox">
            <input 
              type="checkbox" 
              className="custom-control-input" 
              id="crackWidthLimit" 
              checked={this.props.reinforcementToLimit}
              onChange={e => this.props.setReinforcementToLimit(e.target.checked)} />
            <Tooltip content={APP_TOOLTIPS.TOOLTIP_REINFORCEMENT_OPTION.Content}>
            <label className="custom-control-label" htmlFor="crackWidthLimit">
          {APP_TEXTS.MATERIAL_REINFORCEMENT_DESCRIPTION.Content}
              {unitTransform(0.3).from(defaultUnits.DISTANCE).to(this.props.distanceUnit).toFixed(2)}
              {unitLabel(this.props.distanceUnit)}
            </label>
            </Tooltip>
          </div>
        </section>

        <section className="list-type">
          <p>{APP_TEXTS.MATERIAL_REINFORCEMENT_DESCRIPTION2.Content}</p>
          <h4 className="reinforcement__title">{APP_TEXTS.MATERIAL_SERVICE_TEMPERATURE_RANGE.Content}</h4>
          <p>{APP_TEXTS.MATERIAL_SERVICE_TEMPERATURE_RANGE_DESCRIPTION.Content}</p>

          <Tooltip content={APP_TOOLTIPS.TOOLTIP_REINFORCEMENT_LONG_TERM_TEMPERATURE.Content}>
            <Input
              className="reinforcement__label"
              value={unitTransform(this.props.chosenLongTermTemp).from(defaultUnits.TEMPERATURE).to(this.props.temperatureUnit)}
              id="longTermTemperature"
              type="number"
              name="chosenLongTermTemp"
              prefix={APP_TEXTS.MATERIAL_LABEL_LONG_TERM_TEMPERATURE.Content}
              postfix={" " + unitLabel(this.props.temperatureUnit)}
              onUpdate={value => {
                this.props.setReinforcementLongTemp(unitTransform(+value, false)
                  .from(this.props.temperatureUnit)
                  .to(defaultUnits.TEMPERATURE));
              }}
            />
          </Tooltip>

          <p>{APP_TEXTS.MATERIAL_LONG_TERM_TEMP_DESCRIPTION.Content}</p>
          <hr />

          <Tooltip content={APP_TOOLTIPS.TOOLTIP_REINFORCEMENT_SHORT_TERM_TEMPERATURE.Content}>
            <Input
              className="reinforcement__label"
              value={unitTransform(this.props.chosenShortTermTemp).from(defaultUnits.TEMPERATURE).to(this.props.temperatureUnit)}
              id="chosenShortTermTemp"
              type="number" 
              name="chosenShortTermTemp"
              prefix={APP_TEXTS.MATERIAL_LABEL_SHORT_TERM_TEMPERATURE.Content}
              postfix={" " + unitLabel(this.props.temperatureUnit)}
              onUpdate={value => {
                this.props.setReinforcementShortTemp(unitTransform(+value, false)
                  .from(this.props.temperatureUnit)
                  .to(defaultUnits.TEMPERATURE));
              }}
            />
          </Tooltip>

          <p>{APP_TEXTS.MATERIAL_SHORT_TERM_TEMP_DESCRIPTION.Content}</p>
          <hr />

          <h4 className="reinforcement__title">{APP_TEXTS.MATERIAL_LABEL_INSTALLATION_CONDITIONS.Content}</h4>
          <Tooltip content={APP_TOOLTIPS.TOOLTIP_REINFORCEMENT_INSTALLATION_CONDITIONS.Content}>
          <select
            name="chosenCondition"
            className="form-control reinforcement__select"
            value={this.props.chosenCondition}
            onChange={e => this.props.setHoleConditions(e.target.value)}
          >     
            {this.conditions && this.conditions.length && this.conditions.map(n => (
              <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
            ))}
          </select>
          </Tooltip>

          {(Number(this.props.designStd) === standardList['AS5216'] || Number(this.props.designStd) === standardList['EU']) && (
            <select
              name="drillingCondition"
              className="form-control reinforcement__select"
              value={this.props.chosenDrillingCondition}
              onChange={e => this.props.setDrillingConditions(e.target.value)}
            >
              {this.drillingConditions && this.drillingConditions.length && this.drillingConditions.map(n => (
                <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
              ))}
            </select>
          )}
        </section>
      </div>
    );
  }

}

const mapState = state => {
  const {
    plate,
    edge,
    longTemperature,
    shortTemperature,
    holeConditions,
    reinforcementToLimit,
    drillingConditions
  } = state.selectors.material[state.main.appType].reinforcementAndConditions;

  return {
    chosenPlate: plate,
    chosenEdge: edge,
    chosenLongTermTemp: longTemperature,
    chosenShortTermTemp: shortTemperature,
    chosenCondition: holeConditions,
    reinforcementToLimit: reinforcementToLimit,
    chosenDrillingCondition: drillingConditions,

    distanceUnit: state.main.units.distance,
    temperatureUnit: state.main.units.temperature,
    designStd: state.main.localization.designStandard
  };
};

const mapDispatch = dispatch => ({
  setReinforcementPlate: value => dispatch(setReinforcementPlate(value)),
  setReinforcementEdge: value => dispatch(setReinforcementEdge(value)),
  setReinforcementToLimit: value => dispatch(setReinforcementToLimit(value)),
  setReinforcementLongTemp: value => dispatch(setReinforcementLongTemp(value)),
  setReinforcementShortTemp: value => dispatch(setReinforcementShortTemp(value)),
  setHoleConditions: value => dispatch(setHoleConditions(value)),
  setDrillingConditions: value => dispatch(setDrillingConditions(value))
});

var ReinforcementAndConditions_EU = connect(mapState, mapDispatch)(ReinforcementAndConditions_EU_AS);
var ReinforcementAndConditions_AS = connect(mapState, mapDispatch)(ReinforcementAndConditions_EU_AS);

export { ReinforcementAndConditions_EU, ReinforcementAndConditions_AS };
// export default connect(mapState, mapDispatch)(ReinforcementAndConditions_EU_AS);



// WEBPACK FOOTER //
// ./src/views/Material/components/ReinforcementAndConditions/ReinforcementAndConditions_EU_AS.js